import * as Yup from 'yup';

export const ValidationSchemaForMultipleVesselsStepTwo = Yup.object().shape({
      
  objectIds: Yup.array().required(
    "At least one object must be selected"
  ),
});